import { render, staticRenderFns } from "./VideoCallEmpty.vue?vue&type=template&id=45648e80&scoped=true&"
import script from "./VideoCallEmpty.vue?vue&type=script&lang=js&"
export * from "./VideoCallEmpty.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallEmpty.vue?vue&type=style&index=0&id=45648e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45648e80",
  null
  
)

/* custom blocks */
import block0 from "./VideoCallEmpty.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VideoCallEmpty.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports